import React from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { createBusinessOptions } from '../../data/optionsData';

const BusinessOptionsModal = ({ 
  showBusinessOptionsModal,
  setShowBusinessOptionsModal,
  onBusinessTypeSelect,
  isAtBottom,
  scrollBusinessModal,
  theme
}) => {
  const { t } = useLanguage();
  
  // Create business options with translations
  const allBusinessOptions = createBusinessOptions(t);



  const handleBusinessSelect = (businessType) => {
    console.log('🔍 BusinessOptionsModal handleBusinessSelect:', {
      businessType,
      onBusinessTypeSelect: !!onBusinessTypeSelect
    });
    
    console.log('🔍 Calling onBusinessTypeSelect with:', businessType);
    onBusinessTypeSelect(businessType);
    setShowBusinessOptionsModal(false);
  };

  if (!showBusinessOptionsModal) return null;



  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: theme.modalOverlay,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        background: theme.modalBg,
        borderRadius: '24px',
        maxWidth: '900px',
        width: '100%',
        maxHeight: '80vh',
        border: `1px solid ${theme.modalBorder}`,
        boxShadow: `0 20px 40px ${theme.primaryShadow}`,
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Header */}
        <div style={{
          padding: '32px 32px 24px 32px',
          borderBottom: `1px solid ${theme.primaryBorder}`
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '700',
              color: theme.primaryText,
              margin: 0
            }}>
              Select Business Type
            </h2>
            <button
              onClick={() => setShowBusinessOptionsModal(false)}
              style={{
                background: theme.closeButtonBg,
                border: `1px solid ${theme.closeButtonBorder}`,
                color: theme.closeButtonText,
                padding: '8px',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = theme.closeButtonHover;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = theme.closeButtonBg;
              }}
            >
              <X size={20} />
            </button>
          </div>
          
          {/* Description */}
          <p style={{
            margin: '16px 0 0 0',
            color: theme.secondaryText,
            fontSize: '14px',
            lineHeight: '1.5'
          }}>
            Select a business type to get started with Oakland AI.
          </p>
        </div>
        
        {/* Scrollable Content */}
        <div className="business-modal-content" style={{
          flex: 1,
          overflow: 'auto',
          padding: '32px'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
            gap: '20px'
          }}>
            {allBusinessOptions.map((option, index) => (
              <button
                key={index}
                onClick={() => handleBusinessSelect(option.type)}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: '24px',
                  background: theme.cardBg,
                  border: `1px solid ${theme.primaryBorder}`,
                  borderRadius: '20px',
                  color: theme.primaryText,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  textAlign: 'center',
                  minHeight: '140px'
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = theme.cardHoverBg;
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = theme.cardBg;
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                  <div style={{
                    width: '100%',
                    height: '120px',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: theme.quickOptionBg || 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
                    marginBottom: 12,
                    position: 'relative',
                  }}>
                    <img
                      src={option.image}
                      alt={option.label}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '16px',
                      }}
                      onError={(e) => {
                        // Fallback to icon if image fails to load
                        e.target.style.display = 'none';
                        const iconContainer = e.target.nextSibling;
                        if (iconContainer) {
                          iconContainer.style.display = 'flex';
                        }
                      }}
                    />
                    {/* Fallback icon in case image fails to load */}
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      display: 'none',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: theme.quickOptionBg || 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
                    }}>
                      {option.icon}
                    </div>
                  </div>
                <span style={{ fontSize: '16px', fontWeight: '600', lineHeight: '1.3' }}>{option.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessOptionsModal; 